export const SEARCH_CONSTS = {
  moduleName: 'epb-search',

  getters: {
    attributes: 'attributes'
  },
  actions: {
    search: 'search',
    browse: 'browse',
    loadAttributes: 'loadAttributes'
  },
  mutations: {
    setAttributes: 'setAttributes'
  }

};
